import { useChatClass } from "../../theme";
import { AvatarContainer } from "./styled";

export interface AvatarProps {
  /** An image URL which will be rendered as the background. */
  avatar: string;
  /** The size of the avatar
   * @default "small" */
  size?: "small" | "large";
}

interface AvatarComponent extends React.FC<AvatarProps> {
  Container: typeof AvatarContainer;
}

/** Displays an image in a circular frame. */
const Avatar: AvatarComponent = ({ size = "small", avatar }: AvatarProps) => {
  const chatClass = useChatClass();
  return (
    <AvatarContainer
      $size={size}
      style={{ backgroundImage: `url(${avatar})` }}
      className={chatClass("avatar", size)}
      role="img"
      aria-label="Chat assistant avatar"
    />
  );
};
Avatar.Container = AvatarContainer;

export { Avatar };
